import { render, staticRenderFns } from "./app-detail-tieba-rank-entry.vue?vue&type=template&id=f29029a2&scoped=true&"
import script from "./app-detail-tieba-rank-entry.vue?vue&type=script&lang=js&"
export * from "./app-detail-tieba-rank-entry.vue?vue&type=script&lang=js&"
import style0 from "./app-detail-tieba-rank-entry.vue?vue&type=style&index=0&id=f29029a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29029a2",
  null
  
)

export default component.exports